
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g/articles",
      function () {
        return require("private-next-pages/g/articles/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g/articles"])
      });
    }
  